import { useCallback, useEffect, useState } from 'react';

import { fetchNfcCardValues } from 'lib/models/nfcCards';

/**
 * The labels and the responsables the cards have, for the filters of the listing and the
 * suggestions of a new batch. Read again with `refetch` after a batch adds new ones.
 */
function useNfcCardValues() {
	const [labels, setLabels] = useState<string[]>([]);
	const [responsables, setResponsables] = useState<string[]>([]);

	const refetch = useCallback(async () => {
		const [nextLabels, nextResponsables] = await Promise.all([
			fetchNfcCardValues('labels'),
			fetchNfcCardValues('responsables'),
		]);
		setLabels(nextLabels);
		setResponsables(nextResponsables);
	}, []);

	useEffect(() => {
		refetch();
	}, [refetch]);

	return { labels, responsables, refetch };
}

export default useNfcCardValues;
